// extracted by mini-css-extract-plugin
module.exports = {"scroll-to-top":"ButtonScrollToTop_scroll-to-top__GdrbW"};